import React from 'react';

const PaymentPage = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      {/* <iframe
        src="https://epoint.az/az/pay_form_widget?id=5676"
        frameBorder="0"
        allowTransparency="true"
        scrolling="yes"
        width="320"
        height="600"
        title="Payment Form"
        style={{ border: 'none' }}
      ></iframe> */}
      <iframe title="Epoint ödəniş widget" src="https://epoint.az/az/widget?id=5676&type=users"  frameborder="0" allowtransparency="true" scrolling="no" width="180" height="90"></iframe>
    </div>
  );
};

export default PaymentPage;
